import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import "./recharts.css";
import { getTextWidth } from "get-text-width";

const barchartWidth = "100%";

class BarChartSoftdata extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            barData: props.barData || [],
            nomeY: props.nomeY,
            handleBarClick: props.handleBarClick,
            height: 450,
            YAxisWidth: 150,
            displayChart: false,
            minX: 0,
            maxX: 0,
            showErrorModal: false,
            errorMessage: ''
        }

        this.initializeState = this.initializeState.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
    }

    initializeState(props) {
        const barData = props.barData || [];
        
        // Proteção: Se não há dados, não desenha o gráfico e sai da função
        if (barData.length === 0) {
            this.setState({ displayChart: false });
            return;
        }

        let lenBarData = barData.length;
        let heightAux = lenBarData * 40 + 5 * (lenBarData - 2);
        
        if (heightAux < 300) {
            heightAux = 300;
        }

        // Usamos variáveis locais em vez de State para não re-renderizar durante o loop
        let currentMinX = Number.MAX_SAFE_INTEGER;
        let currentMaxX = Number.MIN_SAFE_INTEGER;

        for (let i = 0; i < lenBarData; i++) {
            let row = barData[i];
            let value = parseFloat(row[props.nomeY]) || 0;
            
            if (value >= currentMaxX) {
                currentMaxX = value;
            }
            if (value <= currentMinX) {
                currentMinX = value;
            }
        }

        if (currentMinX > 0) {
            currentMinX = 0;
        }

        // Se por algum motivo os valores ficarem nos limites do sistema, voltamos a 0
        if (currentMaxX === Number.MIN_SAFE_INTEGER) currentMaxX = 0;
        if (currentMinX === Number.MAX_SAFE_INTEGER) currentMinX = 0;
        
        let YAxisWidthAux = 150;
        try {
            // Asseguramos que name é sempre uma String para o getTextWidth não dar erro
            YAxisWidthAux = Math.max(...barData.map(l => getTextWidth(String(l.name || ""))));
        } catch (e) {
            console.error("ERRO [BartChartSoftdata]: Falha ao calcular a largura do texto do eixo Y.", e);
            this.setState({ 
                showErrorModal: true, 
                errorMessage: "Não foi possível processar a formatação visual deste gráfico. Por favor, contate o serviço técnico da DATA E." 
            });
        }

        // Fazemos UM único setState com tudo atualizado
        this.setState({ 
            barData: barData,
            nomeY: props.nomeY,
            handleBarClick: props.handleBarClick,
            height: heightAux, 
            YAxisWidth: YAxisWidthAux + 5,
            minX: currentMinX,
            maxX: currentMaxX,
            displayChart: true 
        });
    }

    componentDidUpdate(prevProps) {
        // Agora verificamos se os dados que vieram do pai mudaram
        if (this.props.barData !== prevProps.barData || this.props.nomeY !== prevProps.nomeY) {
            this.initializeState(this.props);
        }
    }

    componentDidMount() {
        this.initializeState(this.props);
    }

    render() {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                {this.state.displayChart &&
                    <ResponsiveContainer width={barchartWidth} height={this.state.height}>
                        <BarChart
                            width={barchartWidth}
                            height={this.state.height}
                            data={this.state.barData}
                            layout="vertical"
                            margin={{ top: 30, right: 30, left: 0, bottom: 30 }}
                            align="center"
                            onClick={this.state.handleBarClick}
                            barCategoryGap={5}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" tick={{ fontSize: 14 }} domain={[this.state.minX, this.state.maxX]}/>
                            <YAxis width={this.state.YAxisWidth} tick={{ fontSize: 14 }}
                                tickLine={true}
                                tickMargin={5} type="category" dataKey="name" interval={0} />
                            <Tooltip wrapperStyle={{fontSize: "16px"}} cursor={{fill:"#CACACA"}}/>
                            <Bar dataKey={this.state.nomeY}>
                                {this.state.barData.map((datum, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={
                                            (datum[this.state.nomeY] || 0) > 0
                                                ? '#657CB8'
                                                : '#96abda'
                                        }
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                }
                {/* --- MODAL DE ERRO / AVISO (PARA UTILIZADORES FINAIS) --- */}
                {this.state.showErrorModal && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center',
                        alignItems: 'center', zIndex: 3000
                    }}>
                        <div style={{
                            backgroundColor: '#fff', width: '90%', maxWidth: '400px',
                            borderRadius: '5px', padding: '20px', textAlign: 'center',
                            boxShadow: '0 0 20px rgba(0,0,0,0.5)', fontFamily: 'sans-serif'
                        }}>
                            <div style={{ color: '#dc3545', fontSize: '16px' }}>
                                <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>❌</p>
                                <strong style={{ color: '#333' }}>Erro na Apresentação</strong>
                                <p style={{ color: '#333', marginTop: '10px', fontSize: '14px', lineHeight: '1.5' }}>
                                    {this.state.errorMessage}
                                </p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                <button 
                                    style={{
                                        padding: '8px 25px', cursor: 'pointer', borderRadius: '3px',
                                        border: 'none', background: '#dc3545', color: 'white', fontWeight: 'bold'
                                    }} 
                                    onClick={() => this.setState({ showErrorModal: false })}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default BarChartSoftdata;